import { Action } from '../../../../components/MultipleActionsInterfaces';
import AppEnvironment from '../../../../components/enums/appEnvironment.enum';
import StatusChangeDirection from '../../enums/statusChangeDirection.enum';
import { OrderStatus } from '../../interfaces/order-status.interface';
import { SelectedOrder } from '../../list/mass-actions/types/orderListMassActions.types';
import { OrderListSubRows, OrderListWithBaseItem, StatusType } from '../../order.types';
import {
  GetCorrectedMassActionsParams,
  ShowOrderListMassActionByRoleOrAbilityParams,
} from './orderListMassACtions.utilts.types';
import { OrderListMassActionsEnum } from './orderListMassActions';

export const formatSelectedOrder = (
  item: OrderListWithBaseItem | OrderListSubRows,
): SelectedOrder => ({
  orderId: item.orderId,
  orderStatus: item.orderStatus,
  orderSynchronized: item.orderSynchronized,
  orderHasSplit: item.orderSplitSettings.length > 0,
  orderSplitted: item.orderSplitted,
  orderArchived: item.orderArchived,
  lastGatewayPaymentStatus: item.lastGatewayPaymentStatus ?? null,
  lastGatewayPaymentUpdatedAt: item.lastGatewayPaymentUpdatedAt ?? null,
  orderPaymentStatus: item.orderPaymentStatus,
  requirePaymentGateway: !!item.requirePaymentGateway,
  orderType: item.orderType,
});

export const getDesiredStatus = (action: OrderListMassActionsEnum): OrderStatus => {
  switch (action) {
    case OrderListMassActionsEnum.BACK_TO_DRAFT:
      return StatusType.DRAFT;
    case OrderListMassActionsEnum.FINISH_TO_IN_REVISION:
    case OrderListMassActionsEnum.BACK_TO_IN_REVISION:
      return StatusType.IN_REVISION;
    case OrderListMassActionsEnum.FINISH_TO_ON_APPROVAL:
    case OrderListMassActionsEnum.BACK_TO_ON_APPROVAL:
      return StatusType.ON_APPROVAL;
    case OrderListMassActionsEnum.APPROVE_ORDERS:
    case OrderListMassActionsEnum.BACK_TO_APPROVED:
      return StatusType.APPROVED;
    case OrderListMassActionsEnum.MOVE_TO_SENT:
      return StatusType.SENT;
    case OrderListMassActionsEnum.CANCEL_ORDERS:
      return StatusType.CANCELED;
    default:
      throw new Error(`Ação em massa ${action} não tem status desejado correspondente`);
  }
};

export const getStatusChangeDirection = (
  action: OrderListMassActionsEnum,
): StatusChangeDirection => {
  switch (action) {
    case OrderListMassActionsEnum.FINISH_TO_IN_REVISION:
    case OrderListMassActionsEnum.FINISH_TO_ON_APPROVAL:
    case OrderListMassActionsEnum.APPROVE_ORDERS:
    case OrderListMassActionsEnum.MOVE_TO_SENT:
      return StatusChangeDirection.FORWARD;
    case OrderListMassActionsEnum.BACK_TO_DRAFT:
    case OrderListMassActionsEnum.BACK_TO_IN_REVISION:
    case OrderListMassActionsEnum.BACK_TO_ON_APPROVAL:
    case OrderListMassActionsEnum.BACK_TO_APPROVED:
    case OrderListMassActionsEnum.CANCEL_ORDERS:
      return StatusChangeDirection.BACKWARD;
    default:
      throw new Error(
        `Ação em massa ${action} não tem direção de mudança de status correspondente`,
      );
  }
};

export const getCorrectedMassActions = ({
  allMassActions,
  isBrand,
  isOfflineMode,
  userAbility,
  userRole,
  appEnvironment,
}: GetCorrectedMassActionsParams): Action<OrderListMassActionsEnum>[] => {
  const isStoreEnvironment = appEnvironment === AppEnvironment.STORE;

  const filteredActions = allMassActions.filter((action) => {
    if (isOfflineMode) {
      return action.type === OrderListMassActionsEnum.EXPORT_MULTIPLE_ORDERS;
    }

    if (isStoreEnvironment && action.type === OrderListMassActionsEnum.EXPORT_MULTIPLE_ORDERS) {
      return false;
    }

    return (
      action.type !==
      (isBrand
        ? OrderListMassActionsEnum.FINISH_TO_IN_REVISION
        : OrderListMassActionsEnum.FINISH_TO_ON_APPROVAL)
    );
  });

  return filteredActions.filter((action) =>
    canShowOrderListMassActionByRoleOrAbility({ action, userAbility, userRole }),
  );
};

export const canShowOrderListMassActionByRoleOrAbility = ({
  action,
  userAbility,
  userRole,
}: ShowOrderListMassActionByRoleOrAbilityParams): boolean => {
  const hasRole = action.globalRole?.includes(userRole);
  const resourceTypes = action.globalAbility;
  const hasAbility = resourceTypes?.some((resourceType) => userAbility.can('update', resourceType));

  return hasRole || hasAbility || false;
};
